/**
 * Vimium C — All by Keyboard
 *
 * Declares one web-accessible-resource entry — content/*, front/vomnibar* and lib/* —
 * matched to every origin (and chrome-extension pages) with an explicit
 * use_dynamic_url: false. This extension has no bundled images, so detection rests on
 * its vendor-named scripts, which are reachable from any page at a fixed URL.
 *
 * content/vimium-c.js is the cleanest signal — the name is unmistakably this extension's.
 *
 * Manifest verified against version 2.12.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'hfjbmagddngcpeloejdejnfgbamkjaeg';

export const vimiumC: ExtensionDefinition = {
  id: ID,
  name: 'Vimium C - All by Keyboard',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 90_000,
  notes:
    'content/, front/vomnibar* and lib/ exposed to every origin with use_dynamic_url ' +
    'explicitly false. No images, so detection is a fetch of the vendor-named vimium-c.js.',
  signals: [
    {
      id: 'war-vimium-c-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/vimium-c.js — the vendor-named content script exposed to every ' +
        'origin. The name is distinctive to Vimium C.',
      weight: 1,
      run: () => probeFetch(ID, 'content/vimium-c.js'),
    },
    {
      id: 'war-vomnibar-html',
      kind: 'web-accessible-resource',
      description: 'Fetch front/vomnibar.html — the command-bar UI page, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'front/vomnibar.html'),
    },
    {
      id: 'war-injected-end-js',
      kind: 'web-accessible-resource',
      description: 'Fetch content/injected_end.js — a third independent script path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/injected_end.js'),
    },
  ],
};
